import { KeyValueModel } from "model/api";
import { EnumFinalizacaoParcial } from "model/enums/enum-finalizacao-parcial";


export const FinalizacaoParcialMock: KeyValueModel[] = [
  new KeyValueModel(EnumFinalizacaoParcial.QUANTIDADEPRODUTOS, "Inteiro"),  
  new KeyValueModel(EnumFinalizacaoParcial.PARTES, "Partes"),
  new KeyValueModel(EnumFinalizacaoParcial.QUANTIDADEFRACIONADA, "Manual")
];
